import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 12c0 -1.657 1.592 -3 3.556 -3c1.963 0 3.11 1.5 4.444 3c1.333 1.5 2.48 3 4.444 3s3.556 -1.343 3.556 -3","key":"svg-0"}]]

/**
 * IconTilde
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdGlsZGUiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTQgMTJjMCAtMS42NTcgMS41OTIgLTMgMy41NTYgLTNjMS45NjMgMCAzLjExIDEuNSA0LjQ0NCAzYzEuMzMzIDEuNSAyLjQ4IDMgNC40NDQgM3MzLjU1NiAtMS4zNDMgMy41NTYgLTMiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/tilde
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconTilde = createReactComponent('outline', 'tilde', 'Tilde', __iconNode);

export default IconTilde;